import { StyleSheet, css } from 'aphrodite'
import type { StyleDeclaration } from 'aphrodite'
import type React from 'react'

interface Option {
  value: string
  label: string
}

interface SelectProps {
  placeholder: string
  options: Array<{ value: string; label: string }>
  value?: { value: string; label: string }
  onChange: (option?: { value: string; label: string }) => void
  className?: string
  isDisabled?: boolean
}

const Select: React.FC<SelectProps> = ({
  options,
  placeholder,
  onChange,
  className,
  value,
  isDisabled = false,
}) => {
  return (
    <div className={css(styles.selectWrapper, className as StyleDeclaration)}>
      <select
        className={css(styles.select)}
        onChange={(e) => {
          const option = options.find((opt) => opt.value === e.target.value)
          onChange(option)
        }}
        value={value?.value}
        disabled={isDisabled}
      >
        {placeholder && (
          <option value="" disabled selected>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className={css(styles.arrow)}>
        <i className="fa-solid fa-chevron-down" />
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  selectWrapper: {
    position: 'relative',
    width: '100%',
  },
  select: {
    width: '100%',
    padding: '8px 12px',
    paddingRight: '32px', // Space for arrow
    appearance: 'none',
    border: '1px solid rgb(209, 213, 219)',
    borderRadius: '6px',
    backgroundColor: 'white',
    fontSize: '14px',
    color: '#374151',
    cursor: 'pointer',
    ':focus': {
      outline: 'none',
      borderColor: '#1C64F2',
      boxShadow: '0 0 0 1px #1C64F2',
    },
  },
  arrow: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    color: '#6B7280',
    fontSize: '12px',
  },
})

export default Select
